import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { NumberInput: NumberInputColors } = phoneColorKeys.Phone
const { FontColor } = themeColorSectionKeys.defaults

export enum NumberInputVariants {
  Disabled = 'disabled',
  Ready = 'ready',
  Filled = 'filled',
}

const numberInputParts = [
  'container',
  'input',
  'inputRightElement',
  'text',
] as const

const helpers = createMultiStyleConfigHelpers(numberInputParts)

export const NumberInputStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      paddingBottom: '1rem',
      gap: '1.25rem',
      borderBottom: '4px solid',
      borderColor: NumberInputColors.Border,
    },
    input: {
      display: 'flex',
      flex: 1,
      color: FontColor.Default,
      ...textStyles[textStyleKeys.H3],
      letterSpacing: '-0.24px',
      _placeholder: {
        color: NumberInputColors.Placeholder.FontColor,
        textSTyle: textStyleKeys.H3,
        textAlign: 'center',
      },
      paddingRight: 0,
    },
    inputRightElement: {
      height: 'full',
      marginRight: '0.75rem',
      opacity: 0,
      transition: 'opacity 0.15s ease-in-out',
      cursor: 'default',
    },
    text: {
      textStyle: textStyleKeys.Body2_Bold,
    },
  },
  variants: {
    [NumberInputVariants.Disabled]: {
      container: {
        borderColor: NumberInputColors.Disabled.Border,
      },
      input: {
        _placeholder: {
          color: NumberInputColors.Disabled.Placeholder.FontColor,
          ...textStyles[textStyleKeys.H3],
        },
      },
    },
    [NumberInputVariants.Ready]: {},
    [NumberInputVariants.Filled]: {
      inputRightElement: {
        opacity: '100%',
        cursor: 'pointer',
      },
    },
  },
})

export const useNumberInputStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ NumberInputStyle }),
    props,
  ) as MultiStyleType<typeof numberInputParts>
}
